import "./ModalFeedback.css";
import { TextField } from "@mui/material";
import { useState } from "react";

const ModalFeedback = ({ setShowFeedbackModal, handleSubmitFeedback }) => {
  const [feedbackDetail, setFeedbackDetail] = useState("");

  return (
    <div className="modal-feedback-overlay">
      <div className="modal-feedback-content">
        <h2 className="modal-feedback-title">Detalles del Feedback</h2>
        <div className="modal-feedback-input-container">
          <TextField
            id="outlined-multiline-feedback"
            value={feedbackDetail}
            onChange={(e) => setFeedbackDetail(e.target.value)}
            placeholder="¿Cómo podemos mejorar esta respuesta?"
            multiline
            rows={6}
            fullWidth
            sx={{
              "& .MuiOutlinedInput-root": {
                color: "#f1f5f9",
                "& fieldset": {
                  borderColor: "#475569",
                },
                "&:hover fieldset": {
                  borderColor: "#64748b",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#94a3b8",
                },
              },
              "& .MuiInputLabel-root": {
                color: "#94a3b8",
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#94a3b8",
                opacity: 1,
              },
            }}
          />

          <div className="modal-feedback-buttons">
            <button
              className="modal-feedback-btn"
              onClick={() => setShowFeedbackModal(false)}
            >
              Cerrar
            </button>
            <button
              className="modal-feedback-btn"
              onClick={() => {
                handleSubmitFeedback(feedbackDetail);
                setFeedbackDetail("");
              }}
            >
              Enviar Feedback
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalFeedback;
